import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

async function getFile(axios: AxiosInstance, url: string) {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v2/${url}`, {
    responseType: 'arraybuffer',
  });
  return data;
}

export default function useFileQueryV2(url: string | undefined) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    queryKey: getKey(url),
    queryFn: () => getFile(axios, url!),
    enabled: !!url,
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, JSON.stringify(query.error as any));
    }
  }, [query.error, query.isError, toast]);

  return query;
}

export function getKey(url: string | undefined): QueryKey {
  return ['File', url] as const satisfies QueryKey;
}

useFileQueryV2.getKey = getKey;
